export const getMetaContent = (name: string): string | string[] | null => {
  if (typeof window === 'undefined') {
    return null
  }
  const metas = document.querySelectorAll(`meta[name="${name}"]`)
  const meta = metas[metas.length - 1]
  return meta instanceof HTMLMetaElement ? meta.content : null
}

export const isDisallowedUserAgent = (userAgent: string) => {
  const configuredPattern = process.env.NEXT_PUBLIC_DISALLOWED_USER_AGENTS
  if (!userAgent || !configuredPattern) {
    return false
  }

  try {
    return new RegExp(configuredPattern).test(userAgent)
  } catch {
    return false
  }
}

export const isBotUserAgent = () => {
  if (typeof navigator === 'undefined') {
    return false
  }
  return isDisallowedUserAgent(navigator.userAgent)
}
